import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormContainerConfig } from './shared/form-container-config';

@Component({
  selector: 'evland-form-container',
  templateUrl: './form-container.component.html',
  styleUrls: [ './form-container.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class FormContainerComponent {
  config = input.required<FormContainerConfig>();
}
